@if (data.datasets.length > 0) {
<div>
  <canvas
    baseChart
    [data]="data"
    [labels]="labels"
    [options]="options"
    [legend]="false"
    [type]="'doughnut'"
    [height]="height"
  ></canvas>
  <div [innerHtml]="legend" class="legend"></div>
</div>
} @if (data.datasets.length === 0) {
<no-data>No data available</no-data>
}
